import AssignTicketContainer from "./AssignTicketContainer";

export default AssignTicketContainer;